import React from 'react'
import LeafParticles from '../components/LeafParticles/LeafParticles'
import MainAbout from '../components/MainAbout/MainAbout'
import WhyChoose from '../components/WhyChoose/WhyChoose'
import MainTreatment from '../components/MainTreatment/MainTreatment'
import HowItWorks from '../components/HowItWorks/HowItWorks'
import TestimonialSection from '../components/TestimonialSection/TestimonialSection'
import MainGallery from '../components/MainGallery/MainGallery'
import AyurvedaBanner from '../components/AyurvedaBanner/AyurvedaBanner'
import AyurvedaFooter from '../components/AyurvedaFooter/AyurvedaFooter'
import MainSection from '../components/MainSection/MainSection'
import ScrollToTop from '../components/ScrollToTop'
import WhatsAppButton from "../components/WhatsAppButton";
import ScrollTop from '../components/ScrollTop'
import { Helmet } from 'react-helmet-async';

export default function Home() {
  return (
    <>
  <Helmet>
  <title>Ayurmoksha Best Ayurveda Hospital Kozhikode Kerala | Postnatal Care,Rejuvenation Therapy,Hair Treatment,Life Style Guidance & Yoga,Soundarya Kalpa</title>

  <meta
    name="description"
    content="Ayurmoksha Ayurveda Clinic in Kozhikode, Kerala is a trusted center for authentic Ayurvedic healing. We specialize in Postnatal Care, Rejuvenation Therapy, Hair Treatment, Lifestyle Guidance & Yoga, and Soundarya Kalpa. Rooted in traditional Ayurvedic wisdom and guided by experienced practitioners, Ayurmoksha offers holistic treatments designed to restore balance, promote long-term wellness, and support natural healing in a calm riverside setting."
  />

  <meta
    name="keywords"
    content="Ayurvedic Treatment in Kerala,Ayurmoksha Ayurveda Hospital, Ayurveda Hospital in Kozhikode, Postnatal Ayurveda Care in Kerala, Rejuvenation Therapy Ayurveda, Ayurvedic Hair Treatment in Kozhikode, Lifestyle Guidance Ayurveda, Soundarya Kalpa Ayurveda, Traditional Ayurveda Kerala, Holistic Healing Kozhikode"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://ayurmoksha.in/" />

  {/* Open Graph / Social */}
  <meta property="og:locale" content="en_IN" />
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Ayurmoksha Ayurveda Hospital Kozhikode | Authentic Ayurvedic Healing"
  />
  <meta
    property="og:description"
    content="Discover authentic Ayurvedic healing at Ayurmoksha Ayurveda Clinic in Kozhikode, Kerala. Specialized in Postnatal Care, Rejuvenation Therapy, Hair Treatment, Lifestyle Guidance and Yoga, Soundarya Kalpa."
  />
  <meta property="og:url" content="https://ayurmoksha.in/" />
  <meta property="og:site_name" content="Ayurmoksha Ayurveda Hospital" />
  <meta
    property="og:image"
    content="https://ayurmoksha.in/logo.webp"
  />
  <meta
    property="og:image:alt"
    content="Ayurmoksha Ayurveda Hospital Kozhikode Kerala"
  />

  {/* Author */}
  <meta name="author" content="Ayurmoksha Ayurveda Hospital, Kozhikode Kerala" />
</Helmet>



    <div>
           <ScrollTop/>
             <MainSection/>
           
             <LeafParticles />
           <MainAbout/>
            <WhyChoose/>
           <MainTreatment/>
            <HowItWorks/>
            <TestimonialSection/>
              <MainGallery/>
           <AyurvedaBanner/>
                <AyurvedaFooter/> 
              <ScrollToTop/>
               <WhatsAppButton />
             
    </div>
    </>
  )
}
